import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { Row, Col, Modal, ModalBody, ModalFooter } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBell, faPlusCircle } from '@fortawesome/free-solid-svg-icons';
import _ from 'lodash';
import Translate, { t } from '../common/Translate';
import ModalCustomCost from './ModalCustomCost';
import useValue from '../../services/Form/useValue';
import CarPhotoSlider from '../CarProfile/CarPhotoSlider';

const Select = (props) => {
  const { elementIds } = props;
  const { questionId, sectionId, formId } = elementIds;
  const { question, setDisableNav, goNextQuestion } = props;
  const defaultValue = question.default_value;
  const recordId = useSelector((state) => state.reduxRecords?.currentRecord);
  const [value, setValue] = useValue(formId, sectionId, questionId, question.type, 'value', defaultValue);
  const originId = useSelector((state) => state?.reduxRecords?.data[recordId]?.record?.originId);
  const [customCostModalShown, setCustomCostModalShown] = useState(false);
  const [customCostKey, setcustomCostKey] = useState('');
  const [showImage, setShowImage] = useState(false);
  const [leasingModal, setLeasingModal] = useState(false);

  let customCostKeys = [];
  if (Array.isArray(question.custom_cost)) customCostKeys = question.custom_cost;

  let addImageKeys = [];
  if (Array.isArray(question.add_picture)) addImageKeys = question.add_picture;

  useEffect(() => {
    if (setDisableNav !== undefined) {
      if (value !== null && value !== '' && value !== undefined) setDisableNav(false);
      else setDisableNav(true);
    }
  });

  const setImageSliderDisplay = (option) => {
    if (!showImage && addImageKeys.includes(option)) setShowImage(true);
    if (showImage && !addImageKeys.includes(option)) setShowImage(false);
  };

  useEffect(() => {
    let option = value;
    if (typeof option === 'object' && option !== null) option = _.first(_.keys(option));
    setImageSliderDisplay(option);
  });

  const onClick = (option) => {
    if (customCostKeys.includes(option)) {
      setcustomCostKey(option);
      return setCustomCostModalShown(true);
    }
    if ((originId === 12 || originId === 13 || originId === 14) && questionId === 'leasing' && option === 'yes') {
      setLeasingModal(true);
    }
    if (value && (option === value || Object.prototype.hasOwnProperty.call(value, option))) {
      if (showImage) setShowImage(false);
      return setValue(null);
    }
    setValue(option);
    setImageSliderDisplay(option);
    if (!addImageKeys.includes(option) && typeof goNextQuestion === 'function') goNextQuestion();
    return null;
  };

  const closeModal = () => {
    setCustomCostModalShown(false);
  };

  const setCustomValues = (values) => {
    setValue(values);
    closeModal();
    const option = Object.keys(values)[0];
    setImageSliderDisplay(option);
    if (!addImageKeys.includes(option) && typeof goNextQuestion === 'function') goNextQuestion();
  };

  return (
    <>
      <ModalCustomCost
        isOpen={customCostModalShown}
        closeModal={closeModal}
        setCustomValues={setCustomValues}
        customCostKey={customCostKey}
        value={value}
        questionId={questionId}
      />
      {showImage && (
        <CarPhotoSlider
          formId={formId}
          sectionId={sectionId}
          questionId={questionId}
          questionType={question.type}
          resetState={() => {}}
        />
      )}
      <div className="question-select" data-cy={questionId}>
        <Row>
          {question.options.map((option) => (
            <Col xs="6" sm="6" md="4" lg="3" key={option} className="mb-3">
              <button
                type="button"
                className={
                  value !== null &&
                  (value === option ||
                    (typeof value === 'object' && Object.prototype.hasOwnProperty.call(value, option)))
                    ? 'btn btn-block btn-value h-100 selected'
                    : 'btn btn-block btn-value h-100'
                }
                data-cy={option}
                data-test={`${questionId}-${option}-button`}
                onClick={() => onClick(option, questionId)}
              >
                {option === 'has_custom_cost' && (
                  <FontAwesomeIcon className="add-damage-button" size="2x" icon={faPlusCircle} />
                )}
                <Translate code={option} />
              </button>
            </Col>
          ))}
        </Row>
      </div>
      <Modal isOpen={leasingModal} toggle={() => setLeasingModal(false)} centered>
        <ModalBody className="text-center d-flex justify-content-center align-items-center">
          <FontAwesomeIcon icon={faBell} color="red" className="mr-3 fa-lg" />
          <span className="text-danger" style={{ lineHeight: 1.4 }}>
            {t('leasingInformationTextPopUp')}
          </span>
        </ModalBody>
        <ModalFooter className="d-flex justify-content-center pt-1">
          <button type="button" className="btn btn-3" onClick={() => setLeasingModal(false)}>
            {t('close')}
          </button>
        </ModalFooter>
      </Modal>
    </>
  );
};

export default Select;

Select.propTypes = {
  question: PropTypes.shape({
    options: PropTypes.oneOfType([PropTypes.array]).isRequired,
    custom_cost: PropTypes.oneOfType([PropTypes.shape(), PropTypes.array]),
    add_picture: PropTypes.oneOfType([PropTypes.shape(), PropTypes.array]),
    default_value: PropTypes.string,
    type: PropTypes.string.isRequired,
  }),
  elementIds: PropTypes.shape({
    questionId: PropTypes.string.isRequired,
    sectionId: PropTypes.string.isRequired,
    formId: PropTypes.string.isRequired,
  }).isRequired,
  setDisableNav: PropTypes.func,
  goNextQuestion: PropTypes.func,
};

Select.defaultProps = {
  question: {
    custom_cost: undefined,
    add_picture: undefined,
    default_value: null,
  },
  setDisableNav: undefined,
  goNextQuestion: undefined,
};
